export default __webpack_public_path__ + "static/media/trr-food-toast-avocado.b2134d29.png";